// src/store/useTransitionStore.js
import { create } from "zustand";

export const useTransitionStore = create((set) => ({
  screenLoading: false,
  isVisible: false,
  animating: false,
  onComplete: null,
  pendingScreen: null,
  pendingParams: null,

  setScreenLoading: (val) => set({ screenLoading: val }),

  show: (onComplete, screen, params) =>
    set({
      isVisible: true,
      animating: true,
      onComplete,
      pendingScreen: screen,
      pendingParams: params,
    }),

  hide: () =>
    set({
      isVisible: false,
      onComplete: null,
      pendingScreen: null,
      pendingParams: null,
    }),

  endAnimation: () => set({ animating: false }), // ✅ FIXED HERE
}));
